import * as api from '../../api/maintenance/taxTransparency';
import { makeApiActionCreatorV3 } from '../utils';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

const namespace = 'GLOBAL/TAX_TRANSPARENCY';

export const FETCH_LOGIN_SETTINGS = createRequestTypes(
  `${namespace}/FETCH_LOGIN_SETTINGS`,
);

export const fetchLoginSettings = makeApiActionCreatorV3(
  api.fetchLoginSettings,
  FETCH_LOGIN_SETTINGS[START],
  FETCH_LOGIN_SETTINGS[SUCCESS],
  FETCH_LOGIN_SETTINGS[ERROR],
);

export const UPDATE_LOGIN_SETTINGS = createRequestTypes(
  `${namespace}/UPDATE_LOGIN_SETTINGS`,
);

export const updateLoginSettings = makeApiActionCreatorV3(
  api.updateLoginSettings,
  UPDATE_LOGIN_SETTINGS[START],
  UPDATE_LOGIN_SETTINGS[SUCCESS],
  UPDATE_LOGIN_SETTINGS[ERROR],
);

export const FETCH_CHART_TYPE = createRequestTypes(
  `${namespace}/FETCH_CHART_TYPE`,
);

export const fetchChartType = makeApiActionCreatorV3(
  api.fetchChartType,
  FETCH_CHART_TYPE[START],
  FETCH_CHART_TYPE[SUCCESS],
  FETCH_CHART_TYPE[ERROR],
);

export const FETCH_CHART_SETTINGS = createRequestTypes(
  `${namespace}/FETCH_CHART_SETTINGS`,
);

export const fetchChartSettings = makeApiActionCreatorV3(
  api.fetchChartSettings,
  FETCH_CHART_SETTINGS[START],
  FETCH_CHART_SETTINGS[SUCCESS],
  FETCH_CHART_SETTINGS[ERROR],
);

export const UPDATE_CHART_SETTINGS = createRequestTypes(
  `${namespace}/UPDATE_CHART_SETTINGS`,
);

export const updateChartSettings = makeApiActionCreatorV3(
  api.updateChartSettings,
  UPDATE_CHART_SETTINGS[START],
  UPDATE_CHART_SETTINGS[SUCCESS],
  UPDATE_CHART_SETTINGS[ERROR],
);

export const FETCH_STATUS_SETTINGS = createRequestTypes(
  `${namespace}/FETCH_STATUS_SETTINGS`,
);

export const fetchStatusSettings = makeApiActionCreatorV3(
  api.fetchStatusSettings,
  FETCH_STATUS_SETTINGS[START],
  FETCH_STATUS_SETTINGS[SUCCESS],
  FETCH_STATUS_SETTINGS[ERROR],
);

export const UPDATE_STATUS_SETTINGS = createRequestTypes(
  `${namespace}/UPDATE_STATUS_SETTINGS`,
);

export const updateStatusSettings = makeApiActionCreatorV3(
  api.updateStatusSettings,
  UPDATE_STATUS_SETTINGS[START],
  UPDATE_STATUS_SETTINGS[SUCCESS],
  UPDATE_STATUS_SETTINGS[ERROR],
);

export const SEARCH_TAXPAYER_NOTIFICATIONS_EMAILS = createRequestTypes(
  `${namespace}/SEARCH_TAXPAYER_NOTIFICATIONS_EMAILS`,
);

export const searchTaxpayerNotificationsEmails = makeApiActionCreatorV3(
  api.searchTaxpayerNotificationsEmails,
  SEARCH_TAXPAYER_NOTIFICATIONS_EMAILS[START],
  SEARCH_TAXPAYER_NOTIFICATIONS_EMAILS[SUCCESS],
  SEARCH_TAXPAYER_NOTIFICATIONS_EMAILS[ERROR],
);

export const FETCH_NOTIFICATION_RUNS = createRequestTypes(
  `${namespace}/FETCH_NOTIFICATION_RUNS`,
);

export const fetchNotificationRuns = makeApiActionCreatorV3(
  api.fetchNotificationRuns,
  FETCH_NOTIFICATION_RUNS[START],
  FETCH_NOTIFICATION_RUNS[SUCCESS],
  FETCH_NOTIFICATION_RUNS[ERROR],
);

export const CREATE_NOTIFICATION_RUN = createRequestTypes(
  `${namespace}/CREATE_NOTIFICATION_RUN`,
);

export const createNotificationRun = makeApiActionCreatorV3(
  api.createNotificationRun,
  CREATE_NOTIFICATION_RUN[START],
  CREATE_NOTIFICATION_RUN[SUCCESS],
  CREATE_NOTIFICATION_RUN[ERROR],
);

export const FETCH_NOTIFICATION_RUN_RECORDS = createRequestTypes(
  `${namespace}/FETCH_NOTIFICATION_RUN_RECORDS`,
);

export const fetchNotificationRunRecords = makeApiActionCreatorV3(
  api.fetchNotificationRunRecords,
  FETCH_NOTIFICATION_RUN_RECORDS[START],
  FETCH_NOTIFICATION_RUN_RECORDS[SUCCESS],
  FETCH_NOTIFICATION_RUN_RECORDS[ERROR],
);

export const FETCH_NOTIFICATION_RUN_EMAILS = createRequestTypes(
  `${namespace}/FETCH_NOTIFICATION_RUN_EMAILS`,
);

export const fetchNotificationRunEmails = makeApiActionCreatorV3(
  api.fetchNotificationRunEmails,
  FETCH_NOTIFICATION_RUN_EMAILS[START],
  FETCH_NOTIFICATION_RUN_EMAILS[SUCCESS],
  FETCH_NOTIFICATION_RUN_EMAILS[ERROR],
);

export const SET_SEARCH_FORM_DATA = `${namespace}/SET_SEARCH_FORM_DATA`;
export const setFormData = formData => ({
  type: SET_SEARCH_FORM_DATA,
  payload: formData,
});

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_RUNS_PAGE = `${namespace}/CHANGE_RUNS_PAGE`;
export const CHANGE_RUNS_ROWS_PER_PAGE = `${namespace}/CHANGE_RUNS_ROWS_PER_PAGE`;

export const changeRunsPage = page => ({
  type: CHANGE_RUNS_PAGE,
  payload: page,
});

export const changeRunsRowsPerPage = rowsPerPage => ({
  type: CHANGE_RUNS_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_RECORDS_PAGE = `${namespace}/CHANGE_RECORDS_PAGE`;
export const CHANGE_RECORDS_ROWS_PER_PAGE = `${namespace}/CHANGE_RECORDS_ROWS_PER_PAGE`;

export const changeRecordsPage = page => ({
  type: CHANGE_RECORDS_PAGE,
  payload: page,
});

export const changeRecordsRowsPerPage = rowsPerPage => ({
  type: CHANGE_RECORDS_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_EMAILS_PAGE = `${namespace}/CHANGE_EMAILS_PAGE`;
export const CHANGE_EMAILS_ROWS_PER_PAGE = `${namespace}/CHANGE_EMAILS_ROWS_PER_PAGE`;

export const changeEmailsPage = page => ({
  type: CHANGE_EMAILS_PAGE,
  payload: page,
});

export const changeEmailsRowsPerPage = rowsPerPage => ({
  type: CHANGE_EMAILS_ROWS_PER_PAGE,
  payload: rowsPerPage,
});
